import { createAction } from 'redux-actions';

export type AvatarUploadPayload = {
  filename: string;
  file: Blob;
};

export type AvatarUsericonPayload = {
  usericon: string;
};

export type AvatarErrorPayload = AvatarUsericonPayload & {
  error: string;
};

export const uploadAvatar = createAction(
  'AVATAR.UPLOAD.BLOB',
  (payload: AvatarUploadPayload) => payload
);
